export function generateVirtualElement(mousePosition: {
    x: number;
    y: number;
}) {
    if (mousePosition === null) {
        return {
            getBoundingClientRect: () => ({
                width: 0,
                height: 0,
                x: 0,
                y: 0,
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                toJSON: () => '',
            }),
        };
    }
    const { x, y } = mousePosition;
    const boundingBox = {
        width: 0,
        height: 0,
        x,
        y,
        top: y,
        right: x,
        bottom: y,
        left: x,
    };
    return {
        getBoundingClientRect: () => ({
            ...boundingBox,
            toJSON: () => JSON.stringify(boundingBox),
        }),
    };
}
